module.exports = __webpack_public_path__ + "img/hong-kong.76aa7532.svg";